import React from 'react';
import { FiCopy, FiDownload, FiSave, FiX } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

function PromptModal({ isOpen, onClose, promptText, onSave }) {
  const handleCopy = () => {
    navigator.clipboard.writeText(promptText);
    console.log('Prompt copied to clipboard');
  };

  const handleDownload = () => {
    const blob = new Blob([promptText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'promptly-generated-prompt.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
          onClick={onClose}
        >
          <motion.div
            initial={{ y: -50, opacity: 0, scale: 0.95 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: -50, opacity: 0, scale: 0.95 }}
            className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center p-6 border-b border-gray-200">
              <h3 className="text-xl font-semibold text-gray-900">Generated Prompt</h3>
              <button 
                onClick={onClose} 
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <FiX className="h-6 w-6" />
              </button>
            </div>
            
            <div className="p-6 overflow-y-auto max-h-96">
              <textarea
                readOnly
                value={promptText}
                className="w-full h-64 p-4 font-mono text-sm bg-gray-50 border border-gray-200 rounded-lg resize-none focus:outline-none"
              />
            </div>
            
            <div className="flex flex-wrap gap-3 p-6 border-t border-gray-200 bg-gray-50">
              <button 
                onClick={handleCopy} 
                className="btn-secondary"
              >
                <FiCopy className="mr-2 h-4 w-4" /> 
                Copy Prompt
              </button>
              
              <button 
                onClick={handleDownload} 
                className="btn-secondary"
              >
                <FiDownload className="mr-2 h-4 w-4" /> 
                Download .txt
              </button>
              
              {onSave && (
                <button 
                  onClick={onSave} 
                  className="btn-primary"
                >
                  <FiSave className="mr-2 h-4 w-4" /> 
                  Save to Project
                </button>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default PromptModal;